import { closeSnackbar, SnackbarKey } from 'notistack';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';
import { IconCircleCrossFilled } from 'src/general/Icons/IconCircleCrossFilled';
import styles from './carComparisonDismissSnackbarAction.module.scss';

export const carComparisonDismissSnackbarAction = (notificationId: SnackbarKey) => (
  <ButtonIcon
    className={styles.buttonDismiss}
    Icon={IconCircleCrossFilled}
    title="Dismiss"
    onClick={() => closeSnackbar(notificationId)}
    variant="tertiary"
    size="xsmall"
    styling="round"
  />
);
